import {
  InvoicePaymentType,
  Language,
  InvoicePaymentPeriod,
  InvoiceStatus,
  NotificationStatus,
  WalletOrderType,
  ActivityTemplateStatus
} from '@link/admin/services/const';

export default {
  common: {
    edit: '编辑',
    search: '搜索',
    keyword: '关键词',
    action: '操作',
    status: '状态',
    clickToUpload: '上传',
    uploading: '上传中',
    copy: '复制',
    delete: '删除',
    continueConfirm: '是否继续？',
    confirmDelete: '是否删除{{name}}？',
    account: '帐户',
    signOut: '登出'
  },
  layouts: {
    sidebar: {
      contracts: '合同管理',
      suppliers: '供应商管理',
      agents: '旅行社管理',
      finance: '付款管理',
      notifications: '通知管理',
      dataExport: '数据导出',
      activities: '在售商品一览',
      tools: '工具一览',
      opsFreeze: 'OPS冻结'
    }
  },
  views: {
    opsFreeze: {
      separatorHint: '可用换行、空格、逗号（, ，）或顿号（、）分隔',
      register: '登录',
      bookingIdsInput: '输入预约编号',
      maxBookingCount: '最多{{max}}件',
      exceedMaxCount: '已超过最大件数',
      createSuccess: '登录成功',
      freezeOperation: '冻结操作',
      unfreezeOperation: '解冻操作',
      reason: '备注',
      reasonPlaceholder: '请输入操作理由（{{max}}字以内）',
      submitFreeze: '冻结',
      submitUnfreeze: '解冻',
      freezing: '冻结中',
      unfreezing: '解冻中',
      processingHint: '处理完成后将自动下载 CSV',
      freezeSuccess: '冻结已完成',
      unfreezeSuccess: '解冻已完成',
      titleWithCount: '冻结记录一览・{{count}}件',
      newFreeze: '新建冻结',
      batchNo: '编号',
      createdAt: '创建时间',
      status: '状态',
      targetBookings: '对象预约',
      lastOperation: '最终操作',
      bookingCount: '{{count}}件',
      statusLabel: {
        frozen: '已冻结',
        unfrozen: '已解冻',
        notOperated: '未操作'
      },
      action: {
        freeze: '冻结',
        unfreeze: '解冻'
      }
    },
    activities: {
      pageTitle: '在售商品一览',
      searchTitle: '商品检索',
      activityId: '商品ID',
      templateId: 'Template ID',
      activityUrl: '商品URL',
      title: '商品名',
      supplier: '供应商',
      supplierId: '供应商ID',
      supplierName: '供应商名',
      salesStatus: '商品显示',
      listDisplay: '商品列表显示',
      category: '类别',
      country: '商品国家・地区',
      confirmationType: '库存类型',
      inSalePeriod: '销售期间内',
      unspecified: '不指定',
      salePeriod: '销售期间',
      netPrice: '批发价（NET）',
      grossPrice: '销售价（GROSS）',
      unlimited: '无期限',
      downloadCsv: '下载CSV',
      snapshotHint:
        '显示的数据为前一天的数据（每日深夜更新）。最后更新时间：{{time}}',
      templateStatus: {
        [ActivityTemplateStatus.ActivityTemplateStatusPublished]: '已发布',
        [ActivityTemplateStatus.ActivityTemplateStatusReviewing]: '发布申请中',
        [ActivityTemplateStatus.ActivityTemplateStatusApproved]: '发布已确认',
        [ActivityTemplateStatus.ActivityTemplateStatusDraft]: '草稿'
      }
    },
    dataExport: {
      period: '期间',
      dataExport: '数据导出',
      bookingData: '预订数据',
      download: '下载文件',
      monthLabel: '{{year}}年{{month}}月',
      downloadHint: '点击按钮后，在自动下载开始前请勿关闭页面。',
      currentMonthHint: '当月数据将在准备完成后发送至 Slack 频道，请稍候。',
      slackNotice: '数据准备完成后将发送至 Slack 频道',
      notGenerated: '所选期间的数据尚未生成'
    },
    dashboard: {
      title: '仪表板'
    },
    whitelist: {
      title: '白名单',
      add: '添加到白名单',
      alertTitle: '添加旅行社'
    },
    activityPublish: {
      title: '商品发布管理',
      alertTitle: '商品发布确认'
    },
    suppliersList: {
      title: '供应商列表',
      supplierCustomId: '供应商 ID',
      originalName: '供应商名称',
      englishName: '供应商（英文名）',
      country: '国家/地区',
      action: '操作'
    },
    agentsList: {
      title: '旅行社列表',
      originalName: '旅行社名称',
      englishName: '旅行社名称（英文）',
      paymentType: '付款方式',
      country: '国家/地区'
    },
    orgList: {
      title: '群组管理',
      searchLabel: '旅行社'
    },
    agentAccountList: {
      title: '账户管理',
      otaLabel: '旅行社',
      otaOrgLabel: '所属群组'
    },
    apiKeyList: {
      title: 'api-key',
      otaId: '旅行社',
      otaOrgId: '组织',
      createTime: '创建日期',
      addConfirmTitle: '确认新增 API Key',
      deleteConfirmTitle: '确认删除 API Key'
    },
    agentsCharge: {
      title: '余额充值'
    },
    financeTransactions: {
      title: '结算报表',
      transactionStatus: '结算状态',
      keyword: 'ID搜索',
      difference: '交易类型',
      differenceOTA: '旅行社',
      differenceSupplier: '供应商',
      dueDate: '账单发行日',
      invoiceNumber: '账单 ID',
      date: '请款周期',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '货币单位',
      amount: '付款金额合计',
      preAmount: '调整前的请款金额',
      lastAmount: '最终合计金额',
      adjustedAmount: '调整金额',
      finalAmount: '最终合计金额',
      adjust: '调整',
      showjust: '显示',
      paid: '付款完成',
      change: '已付款',
      invoice: '账单明细',
      jaInvoice: '支付通知书(日文)',
      jaInvoiceDetails: '明细书(日文)',
      enInvoice: '支付通知书(英文)',
      enInvoiceDetails: '明细书(英文)',
      attachment: '附件',
      changeTitle: '是否已付款？',
      changeTitlePay: '是否已完成付款？',
      changeMessage: '交易状态将变更为“已付款”',
      changeMessagePay: '交易状态将变更为“入款完成”',
      depositTitle: '交易信息',
      depositDate: '付款日期',
      depositAmount: '付款金额',
      payDate: '支付日期',
      payAmount: '出金金额',
      remark: '备注',
      confirmButton: '已入金',
      invoiceList: '账单列表',
      payNoticeList: '支付通知书列表'
    },
    financeCharge: {
      title: '余额管理',
      agentId: '旅行社 ID',
      agentName: '旅行社名',
      country: '国家/地区',
      method: '支付方式',
      chargeCycle: '结算周期',
      status: '待确认／充值记录',
      includeDeletedAgents: '包含已删除的旅行社',
      bulkDownload: '批量下载',
      downloadTitle: '下载余额记录',
      downloadMessage: '请选择开始时间和结束时间',
      startTime: '开始时间',
      endTime: '结束时间'
    },
    financeChargeHistory: {
      title: '充值记录',
      date: '日期时间',
      amount: '金额',
      invoice: '预付账单',
      status: '交易状态',
      note: '备注',
      code: '确认码',
      change: '操作',
      invoiceStatusConfirmed: '到账确认',
      changeTitle: '已确认到账',
      changeConfirm: '将向该账户执行充值。',
      accountBalance: '账户余额',
      accountBuffer: '账户缓冲金',
      deposit: '付款',
      changeAmount: '修改金额',
      walletTitle: '账户信息',
      amountType: '付款方式'
    },
    webHook: {
      title: 'WebHook设置',
      otaLabel: '旅行社',
      endpoint: 'End point',
      secretToken: 'Secret token'
    },
    notificationsList: {
      title: '手动通知',
      notification: '通知',
      resultCount: '搜索结果：{{count}}条',
      notificationTitle: '通知名称',
      notificationContent: '通知内容',
      sendTime: '发送时间',
      sendStatus: '发送状态',
      deleteConfirmTitle: '是否删除该通知？',
      confirmDelete: '删除',
      deleteWarning: '删除后将无法恢复该通知。',
      addNew: '新增通知',
      send: '发送',
      confirmSend: '发送',
      sendConfirmTitle: '是否发送该通知？',
      sendSuccess: '通知已发送',
      sendFailed: '通知发送失败',
      sendWarning: '发送后无法撤回该通知。',
      resend: '重新发送',
      pin: '置顶',
      unpin: '取消置顶',
      pinConfirmTitle: '是否将该通知置顶？',
      unpinConfirmTitle: '是否取消该通知的置顶？',
      confirmPin: '设为置顶',
      confirmUnpin: '解除',
      pinSuccess: '已置顶',
      pinFailed: '置顶失败',
      unpinSuccess: '已取消置顶',
      unpinFailed: '取消置顶失败',
      failedEmailsTitle: '发送失败详情',
      failedEmailTo: '发送对象',
      failedEmailReason: '失败原因',
      failedEmailsLoadError: '获取失败信息失败',
      noFailedEmails: '没有失败数据'
    },
    notificationDetail: {
      addTitle: '新增通知',
      editTitle: '编辑通知',
      notificationTitle: '通知名称',
      notificationContent: '通知内容',
      relatedProducts: '相关商品',
      productAll: '不相关',
      productSpecified: '指定特定商品',
      productIdsHint: '输入商品ID（以半角逗号分隔）',
      sendTiming: '发送时间',
      sendNow: '立即发送',
      scheduled: '设置时间发送',
      scheduledTime: '预订日期时间',
      editLanguages: '编辑语言',
      editLanguagesRequired: '请选择编辑语言',
      langTitle: '标题',
      langContent: '正文',
      targetScope: '适用范围',
      targetAll: '全部',
      targetTypeEmail: '发送至登录邮箱地址',
      targetTypeRole: '选择权限后发送',
      targetEmailDomain: '对象域',
      targetEmailDomainAdmin: 'Admin',
      targetEmailDomainOta: 'OTA',
      targetEmailDomainSupplier: 'SUP',
      toEmails: '发送对象邮箱地址',
      toEmailsHint: '请输入邮箱地址（以半角逗号“,”分隔）',
      roleOta: 'OTA',
      roleSupplier: 'SUP',
      roleAdmin: 'Admin',
      saveAsDraft: '暂存',
      send: '发送',
      savedAsDraft: '已暂存',
      saveAsDraftFailed: '暂存失败',
      sendSuccess: '通知已发送',
      sendFailed: '通知发送失败'
    }
  },
  const: {
    invoicePaymentType: {
      [InvoicePaymentType.PostBankTransfer]: '后付（银行转账）',
      [InvoicePaymentType.PreLinkpay]: '在线支付（预付款）',
      [InvoicePaymentType.PostLinkpay]: '后付（LinkPay）',
      [InvoicePaymentType.PreCharge]: '银行转账（预付款）'
    },
    invoicePaymentPeriod: {
      [InvoicePaymentPeriod.Monthly]: '月',
      [InvoicePaymentPeriod.Weekly]: '周',
      [InvoicePaymentPeriod.HalfMonthly]: '双周'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '待付款',
      [InvoiceStatus.InvoiceStatusConfirmed]: '付款完成',
      [InvoiceStatus.InvoiceStatusPaid]: '付款确认中',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    },
    walletOrderType: {
      [WalletOrderType.TypeBalance]: '余额充值',
      [WalletOrderType.TypeBuffer]: '缓冲金充值'
    },
    invoicePayStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '付款准备中',
      [InvoiceStatus.InvoiceStatusConfirmed]: '付款完成',
      [InvoiceStatus.InvoiceStatusPaid]: '待入账确认',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    },
    notificationStatus: {
      [NotificationStatus.NotificationStatusSent]: '已发送',
      [NotificationStatus.NotificationStatusTotalFailed]: '发送失败',
      [NotificationStatus.NotificationStatusPartialFailed]: '部分发送失败',
      [NotificationStatus.NotificationStatusSending]: '发送中',
      [NotificationStatus.NotificationStatusTempSaved]: '暂存',
      [NotificationStatus.NotificationStatusScheduled]: '待发送'
    },
    notificationLanguage: {
      [Language.English]: '英语',
      [Language.Japanese]: '日语',
      [Language.Korean]: '韩语',
      [Language.SimplifiedChinese]: '中文(简体)',
      [Language.TraditionalChinese]: '中文(繁体)'
    }
  }
};
